<template>
  <div id="account-page">
    <div id="account-banners-cnt" class="account-notifications-banners">
      <account-card-declined-banner v-if="is_card_declined && !getShowSidebar"/>
      <div class="row mx-0">
        <account-balance-banner v-if="show_balance_banner" @close-balance-banner="hideBalanceBanner"/>
      </div>
    </div>
    <div class="account bg-white">
      <div class="mobile-sm row mx-0">
        <div class="menu-collapsed col-12 px-0">
          <account-sidebar-mobile
            id="account-sidebar-mobile"
            :closeSidebar="closeSidebar"
            :showSidebar="getShowSidebar"
            :routePath="route.path"
            :nextShipmentDate="nextShipmentDate"
          />
        </div>
      </div>
      <div class="container">
        <div id="account-mainframe">
          <div v-if="isMobileXsSm && route.path === '/account/my-subscription'" class="account-header-padding-top mb-3">
            <accountNewHeader />
          </div>
          <div
            id="account-sidebar"
            class="desktop-sm account-header-padding-top"
            style="z-index: 50;"
          >
            <account-sidebar-desktop
              id="account-sidebar-desktop"
              :routePath="route.path"
            />
          </div>
          <div
            v-if="!getShowSidebar && isMobileXsSm || !isMobileXsSm"
            id="account-right-col"
          >
            <router-view v-slot="{ Component, route }" >
              <Transition :name="route.meta.accountTransition || ''">
                <component :is="Component" :key="route.fullPath"/>
              </Transition>
            </router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, onMounted, onUnmounted, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthUser } from '../../utils/stores/modules/authUser/index'
import { useMobileHelpers } from '../utils/composables/mobileHelpers'
import accountSidebarDesktop from './accountSidebarDesktop'
import accountNewHeader from './views/accountNewHeader.vue'
import accountSidebarMobile from './accountSidebarMobile'
import AccountBalanceBanner from './views/accountBalanceBanner.vue'
import AccountCardDeclinedBanner from './elements/AccountCardDeclinedBanner.vue'

const userStore = useAuthUser()
const router = useRouter()
const route = useRoute()
// Props (defineProps)
// Emits (defineEmits)
// Reactive variables (inc composables)
const account_balance_banner_active = ref(true)
const { isMobileXxs, isMobileXsSm, isMobile } = useMobileHelpers()
// Computed
const is_card_declined = computed(() => userStore.userCardDeclined)
const getShowSidebar = computed (() => userStore.getShowSidebar)
const account_balance = computed(() => userStore.accountBalance)
const show_balance_banner = computed(() => {
  return route.name === 'my subscription' && account_balance.value > 0 && !getShowSidebar.value && account_balance_banner_active.value
})
const userType = computed (() => userStore.userType)
const recurrables_state_count = computed(() => userStore.recurrableStateCount)
const number_of_active_plans = computed(() => recurrables_state_count.value?.active)
const number_of_pause_plans = computed(() => recurrables_state_count.value?.paused)
const show_plan_card = computed(() => number_of_active_plans.value > 0 || number_of_pause_plans.value > 0)
const show_only_primary = computed(() => number_of_active_plans.value > 0)
const nextShipmentDate = computed (() => userStore.nextShipmentDate)
const shouldLockScroll = computed(() => getShowSidebar.value && isMobileXsSm.value)
// Methods
function hideBalanceBanner(bool){
  account_balance_banner_active.value = bool
}
function closeSidebar(){
  userStore.closeSidebar()
}
function checkAccountBannersContainer(){
  setTimeout(()=>{
    var cs_banner = document.getElementById('customer-service-banner')
    // balance banner + declined card container
    var account_banners_container = document.getElementById('account-banners-cnt')
    // account mainframe + sidebar desktop
    var account_mainframe = document.getElementById('account-mainframe')
    var account_sidebar = document.getElementById('account-sidebar')
    // sitewide
    var sitewide = document.getElementById('sitewide-banner')
    var sitewide_text =  isMobile.value
      ? document.getElementById('sitewide-banner-text-mobile')?.textContent
      : document.getElementById('sitewide-banner-text-desktop')?.textContent

    var container_height = route.name !== 'my subscription' && !is_card_declined.value && !isMobileXsSm.value ? 0 : account_banners_container.clientHeight
    var navbar_height = isMobileXxs.value ? 60 : 80
    var sitewide_height = sitewide.clientHeight
    var cs_banner_height = cs_banner !== null ? cs_banner.clientHeight : 0
    if(isMobileXsSm.value){
      var my_subs_padding = route.name === 'my subscription' ? 30 : 0
      var padding_top = 0
      if(sitewide && sitewide_text && sitewide_text.length > 0)
        padding_top = my_subs_padding + container_height - sitewide_height
      else padding_top = my_subs_padding + container_height
      account_mainframe.style.paddingTop = `${padding_top+cs_banner_height}px`
      account_mainframe.style.marginTop = '0px'
    } else {
      var margin_top = 0
      if(sitewide && sitewide_text && sitewide_text.length > 0)
        margin_top = navbar_height + container_height - sitewide_height
      else margin_top = navbar_height + container_height
      account_mainframe.style.marginTop = `${margin_top+cs_banner_height}px`
      account_mainframe.style.paddingTop = '0px'
      account_sidebar.style.top = `${container_height !== 0 ? navbar_height + container_height + cs_banner_height : navbar_height + sitewide_height + cs_banner_height}px`
    }
  }, 150)
}
function updateAccountMainframePos(){
  checkAccountBannersContainer()
  window.addEventListener('resize', checkAccountBannersContainer)
}
function updateAccountPositionCSMode(){
  var account_banners_container = document.getElementById('account-banners-cnt')
  var account_mobile_sidebar = document.getElementById('account-sidebar-mobile')
  var cs_banner = document.getElementById('customer-service-banner')
  var cs_banner_height = cs_banner !== null ? cs_banner.clientHeight : 0
  if(cs_banner_height > 0) {
    var navbar_height = isMobileXxs.value ? 60 : 80
    account_banners_container.style.top = `${cs_banner_height + navbar_height + 4}px`
    if(account_mobile_sidebar !== null) account_mobile_sidebar.style.paddingTop = cs_banner_height+'px'
  }
}
function checkCSMode(){
  updateAccountPositionCSMode()
  window.addEventListener('resize', updateAccountPositionCSMode)
}
// Watchers
watch(is_card_declined, () => {
  checkAccountBannersContainer()
})
watch(show_balance_banner, () => {
  checkAccountBannersContainer()
})
watch(userType, (newV) => {
  if(newV === 'B2bUser' || newV === 'D2bUser'){
    router.push({ name: 'B2B' })
  }
})
watch(getShowSidebar, (newV) => {
  if(newV) {
    setTimeout(() => {
      updateAccountPositionCSMode()
    }, 50)
  }
})
watch(shouldLockScroll, (lock) => {
  if (lock) document.body.style.overflow = 'hidden'
  else document.body.style.overflow = ''
})
// Lifecycle Hooks
onBeforeMount(() => {
  var urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('recurrable_id')){
    const recurrable_id = urlParams.get('recurrable_id')
    userStore.getRecurrablebyId(recurrable_id)
  } else {
    if(show_plan_card.value){
      if(show_only_primary.value) userStore.getPrimaryRecurrable()
      else userStore.getPausedRecurrables()
    }
  }
})
onMounted(() => {
  if (userType.value === 'B2bUser' || userType.value === 'D2bUser')
    router.push({ name: 'B2B' })
  userStore.getCoffeesRatings()
  checkCSMode()
  updateAccountMainframePos()
})
onUnmounted(() => { // Ensure scroll is restored when leaving the account page
  document.body.style.overflow = ''
})
// Expose (defineExpose)
</script>
<script>
export default {
	name: 'Account',
}
</script>

<style lang="scss">
@use '../../../assets/sass/inc/default/grid/grid-vue-mixins.scss' as *;


#account {
	#modal-body::-webkit-scrollbar {
		width: 3px;
		background: transparent;
	}

	#modal-body::-webkit-scrollbar-thumb {
		background-color: #1d4045;
		border-radius: 10px;
		border: 3px solid #1d4045;
	}

  .fixed-back-header {
		position: sticky;
		position: -webkit-sticky;
		background-color: white;
		z-index: 50;
		width: 100%;
		height: 50px;

		.account-back-header {
			max-height: 50px;
			border-bottom: 1px solid #1d40454d;
			background-color: #1d40450d;
		}

		.btn-close-sub-nav {
			position: relative;
			padding: 0 0 0 20px;
			text-transform: uppercase;
			font-weight: 600;
			font-size: 14px;
			line-height: 50px;
			width: 100%;
			text-align: left;
			height: 50px;
			color: $brand-secondary;

			&:before {
				content: '\f104';
				font-family: FontAwesome;
				position: absolute;
				left: 0;
				top: 48%;
				@include transform(translateY(-50%));
				font-size: 20px;
				font-weight: 700;
				color: $brand-secondary;
				@include transition(all 0.4s ease);
			}
		}
	}

  #account-sidebar{
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    height: fit-content;
  }

  .account-notifications-banners{
    margin-bottom: 0;
		position: fixed;
		left: 0;
		z-index: 100; //change from 90 to 9999 in order to overlap modals overlays
		min-height: 0px;
		width: 100%;
    top: 80px;
    @media(max-width: 575px) { top: 60px; }
  }
}

.slide-enter-active {
	transition: all 0.5s ease;
}

.slide-leave-active {
	transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-leave-to {
	transform: translateX(100px);
	opacity: 0;
}
.slide-enter-to {
	transform: translateX(-100px);
	display: none;
}

.account-fade-enter-active,
.account-fade-leave-active {
  transition: opacity 0.1s ease 0.1s;
}

.account-fade-enter-from,
.account-fade-leave-to {
  opacity: 0;
}

.account-fade-enter-to,
.account-fade-leave-from  {
  opacity: 1;
}

// .account-fade-enter-active {
//   transition: opacity 0.3s ease-in-out 0.3s;
// }

// .account-fade-leave-active {
//   transition: none;
// }

// .account-fade-enter-from {
//   opacity: 1;
// }

// .account-fade-enter-to {
//   opacity: 1;
// }

// .account-fade-leave-from {
//   opacity: 0;
// }

// .account-fade-leave-to {
//   opacity: 0;
// }

// .account-fade-enter-active,
// .account-fade-leave-active {
//   animation-duration: 0.4s;
//   animation-timing-function: ease-in-out;
//   animation-fill-mode: forwards;
// }

// .account-fade-enter-active {
//   animation-name: fadeIn;
// }

// .account-fade-leave-active {
//   animation-name: fadeOut;
// }

// @keyframes fadeIn {
//   0% { opacity: 0; }
//   25% { opacity: 0.025; }
//   50% { opacity: 0.05; }
//   75% { opacity: 0.1; }
//   100% { opacity: 1; }
// }

// @keyframes fadeOut {
//   0% { opacity: 1; }
//   25% { opacity: 0.05; }
//   50% { opacity: 0.025; }
//   75% { opacity: 0.005; }
//   100% { opacity: 0; }
// }
</style>
